import EntityModel from '@/common/models/entity-model';
import ContactModel from '@/common/models/contact-model';
import PaymentInstrumentModel from './payment-instrument-model';

export default class PaymentCardModel extends EntityModel {
    hydrate({
        id = null,
        customerId = null,
        pan = null,
        bin = null,
        last4 = null,
        expYear = null,
        expMonth = null,
        cvv = null,
        billingAddress,
        token = null,
        safeHash = null,
        status = null,
        brand = null,
        bankCountry = null,
        bankName = null,
        stickyGatewayAccountId = null,
        createdTime = null,
        updatedTime = null,
        customFields = null,
        panFingerprint = null,
    } = {}) {
        this.id = id;
        this.customerId = customerId;
        this.pan = pan;
        this.bin = bin;
        this.last4 = last4;
        this.expYear = expYear;
        this.expMonth = expMonth;
        this.cvv = cvv;
        this.billingAddress = new ContactModel(billingAddress);
        this.token = token;
        this.safeHash = safeHash;
        this.status = status;
        this.brand = brand;
        this.bankCountry = bankCountry;
        this.bankName = bankName;
        this.stickyGatewayAccountId = stickyGatewayAccountId;
        this.createdTime = createdTime;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        this.customFields = customFields;
        this.panFingerprint = panFingerprint;
    }

    getMethod() {
        return PaymentInstrumentModel.getPaymentMethod({...this});
    }
}
